import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Button from "../../components/ui/Button";
import Image from "../../components/AppImage";
import bookSlides from "../../data/bookSlides";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";

const BookDetailSection = () => {
    const { id } = useParams();
    const [showStores, setShowStores] = useState(false);

    const book = bookSlides.find((b) => b.id === parseInt(id, 10));

    if (!book) {
        return (
            <div className="min-h-screen bg-background">
                <Header />
                <main className="pt-16 lg:pt-20">
                    <section className=" py-12">
                        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                            <p className="text-lg text-gray-600">No se encontró el libro.</p>
                        </div>
                    </section>
                </main>
            </div>
        );
    }

    // 🔹 Arreglo de librerías con logos y links
    const stores = [
        {
            name: "Crisol",
            logo: "/assets/images/logo_crisol.png",
            link: book.linkCrisol,
        },
        {
            name: "SBS",
            logo: "/assets/images/logo_sbs.png",
            link: book.linkSBS,
        },
        {
            name: "Ibero",
            logo: "/assets/images/logo_ibero.png",
            link: book.linkIbero,
        },
        {
            name: "BuscaLibre",
            logo: "/assets/images/logo_busca_libre.jpg",
            link: book.linkBuscaLibre,
        },
        {
            name: "Virrey",
            logo: "/assets/images/logo_virrey.png",
            link: book.linkVirrey,
        },
        {
            name: "SUR",
            logo: "/assets/images/logo_sur.png",
            link: book.linkSur,
        },
        {
            name: "Entre Páginas",
            logo: "/assets/images/logo_ep.png",
            link: book.linkSur,
        }

    ].filter((store) => store.link); // solo muestra las que tengan link

    return (
        <div className="min-h-screen bg-background">
            <Header />
            <main className="pt-16 lg:pt-20">
                <section className=" py-12">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
                            {/* Imagen del libro */}
                            <div className="flex justify-center">
                                <Image
                                    src={book.image}
                                    alt={book.title}
                                    className="w-full max-w-sm h-auto object-contain shadow-lg rounded-lg"
                                />
                            </div>

                            {/* Información del libro */}
                            <div>
                                <h1 className="text-3xl font-bold text-literary-navy mb-2">
                                    {book.title}
                                </h1>

                                {/* 🔹 Categoría */}
                                {book.category && (
                                    <p className="text-sm text-gray-500 mb-4">
                                        Categoría: {book.category}
                                    </p>
                                )}

                                {book.sinopsis ? (
                                    <p className="text-base text-gray-700 leading-relaxed whitespace-pre-line mb-8">
                                        {book.sinopsis}
                                    </p>
                                ) : (
                                    <p className="text-base text-gray-500 italic mb-8">
                                        Sinopsis no disponible.
                                    </p>
                                )}

                                {/* 🔹 Botón principal */}
                                <div>
                                    <Button
                                        variant="default"
                                        size="lg"
                                        className="bg-black text-white hover:bg-gray-800"
                                        onClick={() => setShowStores(!showStores)}
                                    >
                                        Comprar
                                    </Button>
                                </div>

                                {/* 🔹 Lista de librerías */}
                                {showStores && (
                                    <div className="mt-6 space-y-4">
                                        {stores.map((store) => (
                                            <div
                                                key={store.name}
                                                className="flex items-center gap-4 p-4 border rounded-lg shadow-sm bg-gray-50"
                                            >
                                                <Image
                                                    src={store.logo}
                                                    alt={store.name}
                                                    className="w-16 h-16 object-contain"
                                                />
                                                <a
                                                    href={store.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <Button
                                                        variant="default"
                                                        size="sm"
                                                        className="bg-burnished-copper hover:bg-burnished-copper/90 text-white"
                                                    >
                                                        COMPRAR
                                                    </Button>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer/>
        </div>
    );
};

export default BookDetailSection;